import * as yup from 'yup';
import { cpf } from '../../../modulos/validation/cpf';

yup.addMethod(yup.string, 'cpf', args => {
    const { message } = args;

    return yup.mixed().test('cpf', message, function (value) {
        const { path, createError } = this;
        const mensagemCPF = 'CPF inválido';

        if (value !== undefined) {
            if (cpf(value) === true) { value = true; }
            else { value = false; }
        } else {
            value = true;
        }

        return value || createError({
            path,
            message: mensagemCPF
        });
    });
});

yup.addMethod(yup.string, 'validateParentesco', args => {
    const { message } = args;

    return yup.mixed().test('validateParentesco', message, function (value) {
        const { path, createError } = this;
        const mensagemvalidateParentesco = 'validateParentesco inválido';

        return value || createError({
            path,
            message: mensagemvalidateParentesco
        });
    });
});

export const validacoesPrimariasFormDependentes = yup.object().shape({
    Nome: yup.string()
        .when('Parentesco', {
            is: value => value?.toUpperCase() === 'PET',
            then: schema => schema.required('Nome e Sobrenome é um campo obrigatório!'),
            otherwise: schema => schema
                .matches(
                    /\b[A-Za-zÀ-ú][A-Za-zÀ-ú]+,?\s[A-Za-zÀ-ú][A-Za-zÀ-ú]{2,19}\b/gi,
                    'Caso o dependente não seja do tipo pet, é necessário preencher nome e sobrenome'
                )
                .required('Nome e Sobrenome é um campo obrigatório!')
        }),
    CPF: yup
        .string()
        .max(15, 'CPF precisa ter 11 caracteres')
        .min(11, 'CPF precisa ter 11 caracteres')
        .cpf('')
        .when('Pagador', {
            is: true,
            then: yup.string().required('CPF é um campo obrigatório!')
        }),
    Telefone: yup.string().min(11, 'Celular precisa ter mais de 11 caracteres.')
        .when('Pagador', {
            is: true,
            then: yup.string().required('Telefone é um campo obrigatório!')
        }),
    DepSexo: yup
        .string()
        .min(5, 'Sexo precisa ter mais de 4 caracteres.')
        .required('Sexo é um campo obrigatório!'),
    Parentesco: yup.string().required('Parentesco é um campo obrigatório!'),
    Categoria: yup.string().required('Valor é um campo obrigatório!'),
    Pagador: yup.boolean().when('Parentesco', {
        is: value => value?.toUpperCase() === 'PET',
        then: yup.boolean().oneOf([false], 'Este Dependente não pode ser Responsável pelo Pagamento')
    }),
    Email: yup.string().email('Email inválido!')
        .when('Pagador', {
            is: true,
            then: yup.string().required('Email é um campo obrigatório!')
        }),
    Idade: yup.number().min(0, 'Idade mínima é de 0 anos').nullable().required('Idade é um campo obrigatório!'),
    showPetForm: yup.boolean(),
    TipoPet: yup
        .string()
        .nullable()
        .when('Parentesco', {
            is: Parentesco => Parentesco === 'PET',
            then: yup.string().required('Tipo do pet é um campo obrigatório!')
        }),
    PesoPet: yup
        .number()
        .positive()
        .nullable()
        .integer()
        .when('Parentesco', (Parentesco, schema) =>
            Parentesco === 'PET' ? schema.required('Peso do pet é um campo obrigatório!') : schema
        )
        .when(['Parentesco', 'Porte'], (Parentesco, Porte, schema) =>
            Parentesco === 'PET' && Porte === '1' ? schema.max(20, 'O valor máximo do peso do PET deve ser de 20kg para o porte pequeno') : Parentesco === 'PET' && Porte === '2' ? schema.max(49, 'O valor máximo do peso do PET deve ser de 49kg para o porte médio') : schema.max(90, 'O valor máximo do peso do PET deve ser de 90kg')
        ).when(['Parentesco', 'Porte'], (Parentesco, Porte, schema) =>
            Parentesco === 'PET' && Porte === '1' ? schema.min(1, 'O valor mínimo do peso do PET deve ser de 1kg para o porte pequeno') : Parentesco === 'PET' && Porte === '2' ? schema.min(30, 'O valor mínimo do peso do PET deve ser de 30kg para o porte médio') : schema.min(50, 'O valor mínimo do peso do PET deve ser de 50kg')
        ),
    CorPet: yup
        .string()
        .min(4, 'Cor do PET tem que ter mínimo 4 dígitos')
        .max(25, 'Cor do PET tem que ter no máximo 25 dígitos')
        .nullable()
        .when('Parentesco', {
            is: Parentesco => Parentesco === 'PET',
            then: yup.string().required('Cor do pet é um campo obrigatório!')
        }),
    CaracteristicasPet: yup
        .string()
        .min(4, 'Raça do PET tem que ter mínimo 4 dígitos')
        .max(25, 'Raça do PET tem que ter no máximo 25 dígitos')
        .nullable()
        .when('Parentesco', {
            is: Parentesco => Parentesco === 'PET',
            then: yup.string().required('Raça do pet é um campo obrigatório!')
        }),
    Porte: yup
        .string()
        .nullable()
        .when('Parentesco', (Parentesco, schema) =>
            Parentesco === 'PET' ? schema.required('Porte do pet é um campo obrigatório!') : schema
        ),
    Plano: yup.string(),
    ValorDependente:
        yup.number().nullable().when('Plano', {
            is: Plano => Plano === 'ZTA',
            then: yup
                .number()
                .min(0, 'Valor do dependente não pode ser negativo!')
                .required('Valor do dependente é um campo obrigatório!')
        })
});
